module.exports = __webpack_public_path__ + "img/dequavian.f60f2e8b.gif";